import React from 'react';

import classNames from 'classnames';

import { sanitizeDescription } from '@/shared/lib/sanitize';
import { getNodeDescription, getNodeTitle } from '@/shared/lib/tree';
import { Tooltip } from '@/shared/ui/Tooltip';

import styles from './TreeNodeTitle.module.css';
import type { TreeNodeTitleProps } from './types';

export const TreeNodeTitle: React.FC<TreeNodeTitleProps> = ({
  nodeData,
  isHighlighted,
  tooltipPlacement = 'rightTop',
}) => {
  const title = getNodeTitle(nodeData);
  const description = getNodeDescription(nodeData);

  const titleClassName = (function () {
    if (isHighlighted) {
      return classNames(styles.highlightedNode, styles.ellipsis);
    }

    return styles.ellipsis;
  })();

  if (!description) {
    return <span className={titleClassName}>{title}</span>;
  }

  return (
    <Tooltip
      placement={tooltipPlacement}
      mouseEnterDelay={0.5}
      title={
        <div className={styles.tooltip}>
          <div className={titleClassName}>{title}</div>
          <div className={styles.tooltipDesc} dangerouslySetInnerHTML={{ __html: sanitizeDescription(description) }} />
        </div>
      }>
      <span className={titleClassName}>{title}</span>
    </Tooltip>
  );
};
